import { useQuery } from '@tanstack/react-query';
import { IPhoneCallOutcome } from '../../aida/viewModels/phonecall';
import { ImpersonationBroker } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/PhoneCallOutcomes';

export function useLeadPhoneCallOutcomesQuery({ meta }: { meta?: LevStandardQueryMeta } = {}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IPhoneCallOutcome[]>(
				ImpersonationBroker.composeApiUrl({ urlPath: `lead/PhoneCallOutcomes` }),
				'GET'
			),
		meta,
	});
}
